import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Trans = (props) => {
  const page = props.id.split('.')[0];
  const translatedMessage =
    (props.translatedMessages
      && props.translatedMessages[page]
      && props.translatedMessages[page][props.id]) ?
      props.translatedMessages[page][props.id] :
      props.children;

  return <span>{translatedMessage}</span>;
};

Trans.propTypes = {
  id: PropTypes.string.isRequired
};

const mapStateToProps = state => ({ translatedMessages: state.translations });

export default connect(mapStateToProps)(Trans);



// WEBPACK FOOTER //
// ./src/Common/Translations/Trans.js